const FormField = ({
    type = 'text',
    name,
    label,
    value,
    onChange,
    onBlur,
    placeholder = ' ',
    error,
    touched,
    disabled = false,
    className = '',
    required = false,
    helpText,
    children,
    customLabel,
    inputMode = 'text',
    addBottomBorder = true,
    ...props
}) => {
    const hasError = error && touched;
    const showRequired = required && label;

    if (children) {
        // Custom field content (for dropdowns, etc.)
        return (
            <div
                className={`relative w-full mb-7 group ${className}`}
                data-field={name}
                id={`field-${name}`}
            >
                {label && (
                    <label
                        htmlFor={name}
                        className={`peer-focus:font-medium text-sm ${
                            hasError
                                ? 'text-red-500'
                                : 'text-gray-500 peer-focus:text-black'
                        } `}
                    >
                        {label}
                        {showRequired && (
                            <span className='text-red-500 ml-1'>*</span>
                        )}
                    </label>
                )}
                <div
                    className={`${addBottomBorder ? 'border-b-2' : ''} ${
                        hasError ? 'border-red-500' : 'border-gray-600'
                    }`}
                >
                    {children}
                </div>
                {hasError && (
                    <p className='absolute mt-1 text-red-600 text-xs'>
                        {error}
                    </p>
                )}
                {!hasError && helpText && (
                    <p className='absolute mt-1 text-gray-400 text-xs'>
                        {helpText}
                    </p>
                )}
            </div>
        );
    }

    if (type === 'textarea') {
        return (
            <div
                className={`relative w-full mb-7 group ${className}`}
                data-field={name}
                id={`field-${name}`}
            >
                <label
                    htmlFor={name}
                    className={`peer-focus:font-medium text-sm ${
                        hasError
                            ? 'text-red-500'
                            : 'text-gray-500 peer-focus:text-black'
                    } `}
                >
                    {label}
                    {showRequired && (
                        <span className='text-red-500 ml-1'>*</span>
                    )}
                </label>
                <textarea
                    name={name}
                    id={name}
                    value={value || ''}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    disabled={disabled}
                    className={`border-b-2 ${
                        hasError
                            ? 'border-red-500'
                            : 'border-gray-600 focus:border-blue-500'
                    } block pt-3 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent appearance-none focus:outline-none focus:ring-0 peer placeholder:text-center transition-colors duration-200 resize-none`}
                    rows={1}
                    {...props}
                />
                {hasError && (
                    <p className='absolute mt-1 text-red-600 text-xs'>
                        {error}
                    </p>
                )}
                {!hasError && helpText && (
                    <p className='absolute mt-1 text-gray-400 text-xs'>
                        {helpText}
                    </p>
                )}
            </div>
        );
    }

    return (
        <div
            className={`relative w-full mb-7 group ${className}`}
            data-field={name}
            id={`field-${name}`}
        >
            {customLabel ? (
                customLabel
            ) : (
                <label
                    htmlFor={name}
                    className={`peer-focus:font-medium text-sm ${
                        hasError
                            ? 'text-red-500'
                            : 'text-gray-500 peer-focus:text-black'
                    } `}
                >
                    {label}
                    {showRequired && (
                        <span className='text-red-500 ml-1'>*</span>
                    )}
                </label>
            )}
            <input
                type={type}
                name={name}
                id={name}
                value={value || ''}
                onChange={onChange}
                inputMode={inputMode}
                onBlur={onBlur}
                placeholder={placeholder}
                disabled={disabled}
                className={`border-b-2 ${
                    hasError
                        ? 'border-red-500'
                        : 'border-gray-600 focus:text-black'
                } block pt-3 pb-1 px-0 w-full text-sm text-gray-900 bg-transparent appearance-none focus:outline-none focus:ring-0 peer transition-colors duration-200`}
                {...props}
            />
            {hasError && (
                <p className='absolute text-red-600 text-xs'>{error}</p>
            )}
            {!hasError && helpText && (
                <p className='absolute text-gray-400 text-xs'>{helpText}</p>
            )}
        </div>
    );
};

export default FormField;
